import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const List16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.4 1.25C1.76487 1.25 1.25 1.76487 1.25 2.4V5.6C1.25 6.23513 1.76487 6.75 2.4 6.75H5.6C6.23513 6.75 6.75 6.23513 6.75 5.6V2.4C6.75 1.76487 6.23513 1.25 5.6 1.25H2.4ZM2.75 5.25V2.75H5.25V5.25H2.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.4 9.25C1.76487 9.25 1.25 9.76487 1.25 10.4V13.6C1.25 14.2351 1.76487 14.75 2.4 14.75H5.6C6.23513 14.75 6.75 14.2351 6.75 13.6V10.4C6.75 9.76487 6.23513 9.25 5.6 9.25H2.4ZM2.75 13.25V10.75H5.25V13.25H2.75Z'
      fill='currentColor'
    />
    <path d='M16 2.75H8V1.25H16V2.75Z' fill='currentColor' />
    <path d='M8 10.75H16V9.25H8V10.75Z' fill='currentColor' />
    <path d='M14 5.75H8V4.25H14V5.75Z' fill='currentColor' />
    <path d='M8 13.75H14V12.25H8V13.75Z' fill='currentColor' />
  </Svg>
);

List16.displayName = 'List16';
export default List16;
